// Review timestamps returned without an offset are UTC server timestamps.
// Keep this normalization local: closing deadlines are Brasília wall-clock dates.
export function reviewDate(value) {
  const text = typeof value === "string" ? value.trim() : value;
  const utcValue = typeof text === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?$/.test(text)
    ? `${text}Z`
    : text;
  return new Date(utcValue);
}

export function formatReviewDate(value, includeTime = false) {
  if (!value) return "—";
  const date = reviewDate(value);
  if (Number.isNaN(date.getTime())) return value;
  const options = { timeZone: "America/Sao_Paulo" };
  const day = date.toLocaleDateString("pt-BR", options);
  return includeTime
    ? `${day} ${date.toLocaleTimeString("pt-BR", { ...options, hour: "2-digit", minute: "2-digit", hour12: false })}`
    : day;
}
